import React from 'react';
import Pagination10 from './Pagination10';

const PaginationBar = ({ setPagination }) => (
  <div style={{ padding: '0.5rem 1rem', borderTop: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#f8f9fa' }}>
    <Pagination10 {...setPagination} />
  </div>
);

export default PaginationBar;
